import { AlertTriangle, Wrench } from 'lucide-react';

function Maintenance() {
  return (
    <div style={styles.container}>
      <div style={styles.card}>
        <div style={styles.iconWrapper}>
          <AlertTriangle size={48} color="#ff9800" />
        </div>
        <h1 style={styles.title}>Even offline</h1>
        <p style={styles.text}>SpotjeWcPotje is tijdelijk niet beschikbaar voor onderhoud. We zijn zo snel mogelijk weer terug!</p>
        <div style={styles.badge}><Wrench size={13} style={{ marginRight: 6, verticalAlign: 'middle' }} /> Onderhoud bezig</div>
      </div>
    </div>
  );
}

const styles = {
  container: { display: 'flex', justifyContent: 'center', alignItems: 'center', minHeight: '100vh', backgroundColor: '#f8fafc', padding: '20px' },
  card: { backgroundColor: 'white', borderRadius: '20px', padding: '48px 32px', boxShadow: '0 4px 20px rgba(0,0,0,0.1)', display: 'flex', flexDirection: 'column', alignItems: 'center', gap: '16px', textAlign: 'center', maxWidth: '400px', width: '100%' },
  iconWrapper: { width: '80px', height: '80px', borderRadius: '50%', backgroundColor: '#fff8e1', display: 'flex', alignItems: 'center', justifyContent: 'center' },
  title: { margin: 0, fontSize: '28px', fontWeight: '800', color: '#222' },
  text: { margin: 0, fontSize: '15px', color: '#666', lineHeight: '1.7' },
  badge: { backgroundColor: '#fff8e1', color: '#ff9800', padding: '8px 16px', borderRadius: '20px', fontSize: '13px', fontWeight: '600' }
};

export default Maintenance;